import { SuiteConstants } from './types';

export const initialState = {
  allSuites: [],
  formattedSuiteList: [],
  graphDateRange: {
    value: '48Hours',
    label: 'Past 48 Hours',
    startDatetime: undefined,
    endDatetime: undefined,
  },
  selectedSuite: {
    value: '',
    label: '',
  },
  selectedBuilding: '',
  suiteData: {
    date: '',
    point_data: [],
    report_unit: '',
  },
  allSuiteDataPoints: [],
  selectedSuiteDataPoints: [],
  suiteDetails: {},
  error: undefined,
  isFetching: false,
  suiteLineColors: {},
  availableSuiteLineColors: undefined,
};

export function suiteReducer(state = initialState, action) {
  switch (action.type) {
    case SuiteConstants.SetSelectedBuilding:
      return {
        ...state,
        selectedBuilding: action.payload,
      };
    case SuiteConstants.ClearSuiteData:
      return {
        ...initialState,
      };
    case SuiteConstants.ReceiveSuiteData:
      return {
        ...state,
        suiteData: action.payload,
        error: undefined,
      };
    case SuiteConstants.ReceiveSuiteDataPoints:
      return {
        ...state,
        allSuiteDataPoints: action.payload.points,
        error: undefined,
      };
    case SuiteConstants.ReceiveSuiteDetails:
      return {
        ...state,
        suiteDetails: action.payload,
        error: undefined,
      };
    case SuiteConstants.ReceiveSuiteList:
      return {
        ...state,
        allSuites: action.payload,
        error: undefined,
      };
    case SuiteConstants.FormattedSuiteList:
      return {
        ...state,
        formattedSuiteList: action.payload,
      };
    case SuiteConstants.SetSelectedSuite:
      return {
        ...state,
        selectedSuite: action.payload,
      };
    case SuiteConstants.SuiteError:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    case SuiteConstants.UpdateLineColorsObj:
      return {
        ...state,
        suiteLineColors: action.payload,
      };
    case SuiteConstants.UpdateAvailableColors:
      return {
        ...state,
        availableSuiteLineColors: action.payload,
      };
    case SuiteConstants.UpdateSelectedPointsList:
      return {
        ...state,
        selectedSuiteDataPoints: action.payload,
      };
    case SuiteConstants.StartLoading:
      return {
        ...state,
        isFetching: true,
      };
    case SuiteConstants.FinishLoading:
      return {
        ...state,
        isFetching: false,
      };
    case SuiteConstants.UpdateGraphDateRange:
      return {
        ...state,
        graphDateRange: action.payload,
      };
    default:
      return state;
  }
}
